import { render, staticRenderFns } from "./trade-contact.vue?vue&type=template&id=312f5c73&scoped=true&"
import script from "./trade-contact.vue?vue&type=script&lang=js&"
export * from "./trade-contact.vue?vue&type=script&lang=js&"
import style0 from "./trade-contact.vue?vue&type=style&index=0&id=312f5c73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f5c73",
  null
  
)

export default component.exports